<script>
export default {
  name: "DidoMillesimeInputFilterMultiple",
};
</script>

<script setup>
import { ref, computed, watch } from "vue";
import { apiValueToLocaleString } from "../../../utils";

// define Props
const props = defineProps({
  modelValue: { type: String, required: false, default: "" },
  label: { type: Boolean, required: true },
  type: { type: String, required: true },
});

// define watchers
watch(
  () => [props.modelValue],
  () =>
    (inputValue.value = props.modelValue
      ? props.modelValue.split("$SEPARATOR$")
      : []),
);

// define Emits
const emit = defineEmits(["update:model-value"]);

// define reactive data
const inputValue = ref(
  props.modelValue ? props.modelValue.split("$SEPARATOR$") : [],
);

// computed data to check if it's a number value
const isNumber = computed(() => ["number", "integer"].includes(props.type));

const formatSingle = (val) =>
  val && isNumber.value
    ? String(val).replace(/,/g, ".").replace(/\s/g, "")
    : val;
// define computed value for formatting input value
const formattedValue = computed(() =>
  inputValue.value.map((val) => formatSingle(val)).join("$SEPARATOR$"),
);
</script>

<template>
  <QSelect
    ref="selectedChips"
    v-model="inputValue"
    dense
    square
    outlined
    stack-label
    multiple
    use-chips
    use-input
    hide-dropdown-icon
    class="dido-millesimefilter-multiple"
    :label="label ? 'Saisissez des valeurs' : ''"
    new-value-mode="add-unique"
    @update:model-value="emit('update:model-value', formattedValue)"
  >
    <template #selected-item="{ removeAtIndex, index, tabindex, opt }">
      <QChip
        removable
        :label="apiValueToLocaleString(opt, props.type)"
        size="sm"
        color="secondary"
        text-color="black"
        :tabindex="tabindex"
        class="text-small text-bold"
        @remove="removeAtIndex(index)"
      />
    </template>
  </QSelect>
</template>

<style lang="sass" scoped>
.dido-millesimefilter-multiple
  min-width: 150px
</style>
